export default __webpack_public_path__ + "static/media/x-mark.5ef1222a.svg";